import { PButton } from 'components/prime/PButton/PButton';
import styled from 'styled-components';
import { LayoutDashboardLeftMenuButtonStyle } from '../../LayoutDashboardLeftMenu.style';
import { colourPalette } from 'styles/styles';

export const LayoutDashboardLeftMenuItemStyle = {
  Button: styled(PButton)`
    ${LayoutDashboardLeftMenuButtonStyle}
    position: relative;
    z-index: 1;

    .button-custom-label {
      color: ${colourPalette.neutral400} !important;
    }
    .button-custom-icon-wrapper,
    .button-icon-custom-wrapper {
      width: 24px !important;
      height: 24px !important;
    }

    &.is-active,
    &:hover {
      z-index: 1;
      .button-custom-label {
        color: ${colourPalette.neutral600} !important;
      }
    }

    &:active .button-custom-label {
      color: ${colourPalette.neutral400} !important;
    }

    &.is-settings {
      .button-custom-label {
        color: ${colourPalette.neutral500} !important;
      }

      &.is-active,
      &:hover {
        .button-custom-label {
          color: ${colourPalette.neutral600} !important;
        }
      }

      &:active .button-custom-label {
        color: ${colourPalette.neutral500} !important;
      }
    }
  `,
};
